module.exports = __webpack_public_path__ + "media/images/rhs_bn02-21c5dbc14c74d8f2d03c11fde686c7fc.jpg";